import MediaQuery from 'react-responsive';
import ExpandableMenu from './ExpandableMenu';
import { useEffect, useState } from 'react';

const ExpandableMenuContainer=({navItem})=>{
    const [isVisible,setIsVisible]=useState(false);

    useEffect(()=>{
        setIsVisible(true);
    },[]);

    return(
        <>
            {
                isVisible?
                    <MediaQuery query="(max-width: 1023px)">
                        <ExpandableMenu navItem={navItem}/>
                    </MediaQuery>
                :
                    null
            }
        </>
        
    )
}

export default ExpandableMenuContainer;